import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Frame from "react-frame-component";
import SizeSelector from "../utils/size-selector";
import { openLink } from "../utils/helpers";
import Loading from "../../app/loading";
import "./banner.css";

let css = `body {
  margin: 0;
  padding: 0;
}
#bannerImg {
  height: auto;
  display: block;
  margin: 0 auto;
  width: 100%;
}
.img-container {
  display: block;
  margin: 0 auto;
}
.img-container.fit-size #bannerImg {
  max-height: 250px;
  width: auto;
}`;

const compare = (a, b) => {
  if (parseInt(a.maxWidth) > parseInt(b.maxWidth)) return 1;
  if (parseInt(b.maxWidth) > parseInt(a.maxWidth)) return -1;

  return 0;
};

const Banner = ({ banner, includeSizeToFit, selectors, retailer }) => {
  const sizeToFit = useSelector((state) => state.sizeToFit);
  const [defaultImage, setDefaultImage] = useState();
  const [images, setImages] = useState();

  useEffect(() => {
    if (banner.fields) {
      setDefaultImage(banner.fields[Object.keys(banner.fields)[0]]);
    }
  }, [banner]);

  useEffect(() => {
    if (banner.fields) {
      let arr = _.map(banner.fields, (field) => {
        return field;
      });
      arr.sort(compare);
      const f = _.find(arr, (o) => {
        return o.density === "TWO_TO_ONE";
      });
      if (f) {
        const filteredImages = _.filter(arr, (image) => {
          return image.density === "TWO_TO_ONE";
        });
        setImages(filteredImages);
      } else {
        setImages(arr);
      }
      //_.map(arr, (field) => {
      //  css += `@media (max-width: ${field.maxWidth}px) {
      //    .img-container {
      //      max-width: ${field.width}px;
      //    }
      //    .img-container #bannerImg {
      //      max-height: ${field.height}px;
      //    }
      //  }`;
      //});
      //setImages(arr);
    }
  }, [banner]);

  if (!banner) return <Loading />;

  return (
    <SizeSelector selectors={selectors} includeSizeToFit={includeSizeToFit}>
      <div className={retailer}>
        <Frame
          initialContent={`<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" /><style>${css}</style></head><body><div id="bannerFrame"></div></body></html>`}
          mountTarget="#bannerFrame"
        >
          <div className="wrapper">
            <div className={`img-container ${sizeToFit ? "fit-size" : ""}`}>
              <a
                href={banner.bannerURL}
                id="ref"
                onClick={(e) => openLink(e, banner.bannerURL)}
              >
                <picture>
                  {images &&
                    _.map(images, (image, index) => (
                      <source
                        media={`(max-width: ${image.maxWidth}px)`}
                        srcSet={`${image.path} ${image.width}w`}
                        sizes={`${image.width}px`}
                        key={`${image.name}${index}`}
                      />
                    ))}
                  {defaultImage && (
                    <img
                      alt={banner.alt}
                      id="bannerImg"
                      src={defaultImage.path}
                    />
                  )}
                </picture>
              </a>
            </div>
          </div>
        </Frame>
      </div>
    </SizeSelector>
  );
};

export default Banner;
